import { Link as RouterLink } from 'react-router-dom'

import clsx from 'clsx'
import PropTypes from 'prop-types'

import {
  AppBar,
  IconButton,
  Toolbar,
  SvgIcon,
  Box,
  makeStyles,
  Hidden,
} from '@material-ui/core'

import { Account } from './components'

import { Menu as MenuIcon } from 'react-feather'

import styles from './styles'
import Logo from 'images/dponet-logo-white.svg'
import { useAuth } from 'hooks'

const useStyles = makeStyles(styles)

const TopBar = ({
  className,
  onMobileNavOpen = () => {},
  withSidebar = false,
  ...rest
}) => {
  const classes = useStyles()
  const auth = useAuth()

  return (
    <AppBar className={clsx(classes.root, className)} {...rest}>
      <Toolbar className={classes.toolbar}>
        <Box>
          {withSidebar ? (
            <>
              <Hidden mdDown>
                <RouterLink to={auth.homePage}>
                  <img
                    alt="Logo"
                    src={Logo}
                    className={classes.logo}
                    width="130px"
                  />
                </RouterLink>
              </Hidden>
              <Hidden lgUp>
                <IconButton
                  className={classes.menuButton}
                  color="inherit"
                  onClick={onMobileNavOpen}
                >
                  <SvgIcon fontSize="small">
                    <MenuIcon />
                  </SvgIcon>
                </IconButton>
              </Hidden>
            </>
          ) : (
            <RouterLink to={auth.homePage}>
              <img
                alt="Logo"
                src={Logo}
                className={classes.logo}
                width="100%"
              />
            </RouterLink>
          )}
        </Box>
        <Box ml={2} flexGrow={1} />

        {/* Comentado  ate possuirmos uma base de conhecimento no Tomticket*/}

        {/* <Box display="flex" justifyContent="flex-end" mr={5}>
          <Tooltip title="Acesso a documentação">
            <Chip
              className={classes.helpChip}
              onClick={() => handleHelp()}
              icon={<HelpCircleIcon className={classes.iconChip} />}
              label="Ajuda"
              clickable={false}
            />
          </Tooltip>
        </Box> */}
        <Account />
      </Toolbar>
    </AppBar>
  )
}

TopBar.prototype = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
}

export default TopBar
